"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactForm = _interopRequireDefault(require("@micado-digital/react-form"));

var _FormContent = _interopRequireDefault(require("./FormContent"));

var _Login = _interopRequireDefault(require("./Login.styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Login = function Login(_ref) {
  var lang = _ref.lang,
      url = _ref.url,
      onChange = _ref.onChange,
      onError = _ref.onError,
      onSuccess = _ref.onSuccess;
  var REACT_APP_PATH = process.env.REACT_APP_PATH;
  var css = (0, _Login.default)();
  var actionURL = url ? url : "".concat(REACT_APP_PATH, "/login.internal");
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.login, "mco-login-form-login")
  }, /*#__PURE__*/_react.default.createElement(_reactForm.default, {
    action: actionURL
  }, /*#__PURE__*/_react.default.createElement(_FormContent.default, {
    lang: lang,
    onChange: onChange,
    onError: onError,
    onSuccess: onSuccess
  })));
};

var _default = Login;
exports.default = _default;